import { render } from "./LevelIndicatorComponent.vue?vue&type=template&id=3a3df900&scoped=true"
import script from "./LevelIndicatorComponent.vue?vue&type=script&lang=js"
export * from "./LevelIndicatorComponent.vue?vue&type=script&lang=js"

import "./LevelIndicatorComponent.vue?vue&type=style&index=0&id=3a3df900&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a3df900"]])

export default __exports__